import { AccConnectFormSubmitProps } from '@types';
import React, { useEffect, useRef } from 'react';

const AccConnectFormSubmit: React.FC<AccConnectFormSubmitProps> = ({ method, action, value }) => {
    const formRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (method && action && value) {
            formRef.current.click();
        }
    });

    return (
        <form method={method} action={action}>
            <input type="hidden" value={value} name="Token" />
            <input type="submit" ref={formRef} hidden />
        </form>
    );
};

export default React.memo(AccConnectFormSubmit);
